module.exports = __webpack_public_path__ + "static/media/attack.5a6b6a11.JPG";